import {
  FetchCommunityFinancialsResponseFinancialSummary,
  FetchDirectorFinancialDetailsResponse,
  ProgramType,
} from '../swagger'

export const currencyCode = 'USD'

export const mockCommunityFinancialResponse: FetchCommunityFinancialsResponseFinancialSummary[] =
  [
    {
      actorKey: 1,
      firstName: 'Dwayne',
      lastName: 'Smith',
      roleName: 'Licensed Community Director',
      totalDirectorOwe: {
        amount: '1200.00',
        currencyCode,
      },
      totalTutorsOwe: {
        amount: '5200.00',
        currencyCode,
      },
      totalFamiliesOwe: {
        amount: '22000.00',
        currencyCode,
      },
      totalFamiliesOweDirector: {
        amount: '25000.00',
        currencyCode,
      },
    },
    {
      actorKey: 2,
      firstName: 'Bill',
      lastName: 'Thompson',
      roleName: 'Licensed Community Director',
      totalDirectorOwe: {
        amount: '2300.00',
        currencyCode,
      },
      totalTutorsOwe: {
        amount: '8500.00',
        currencyCode,
      },
      totalFamiliesOwe: {
        amount: '35000.00',
        currencyCode,
      },
      totalFamiliesOweDirector: {
        amount: '25000.00',
        currencyCode,
      },
    },
  ]

export const mockDirectorFinancialDetailsResponse: FetchDirectorFinancialDetailsResponse =
  {
    programs: [
      {
        programType: ProgramType.Foundations,
        tutorOwesDirector: {
          amount: '500.00',
          currencyCode: 'USD',
        },
        familyOwesTutor: {
          amount: '1200.00',
          currencyCode: 'USD',
        },
        tutorCount: 1,
        familyCount: 3,
        familiesOweDirector: {
          amount: '1500.00',
          currencyCode: 'USD',
        },
        tutors: [
          {
            firstName: 'Alice',
            lastName: 'Johnson',
            enrollmentCount: 3,
            tutorOwesDirector: {
              amount: '200.00',
              currencyCode: 'USD',
            },
            familiesOweTutor: {
              amount: '600.00',
              currencyCode: 'USD',
            },
            familiesOweDirector: {
              amount: '500.00',
              currencyCode: 'USD',
            },
            families: [
              {
                userKey: 1001,
                firstName: 'The',
                lastName: 'Smith Family',
                familyOwesTutor: {
                  amount: '200.00',
                  currencyCode: 'USD',
                },
                familyOwesDirector: {
                  amount: '700.00',
                  currencyCode: 'USD',
                },
              },
              {
                userKey: 1002,
                firstName: 'The',
                lastName: 'Martinez Family',
                familyOwesTutor: {
                  amount: '200.00',
                  currencyCode: 'USD',
                },
                familyOwesDirector: {
                  amount: '800.00',
                  currencyCode: 'USD',
                },
              },
              {
                userKey: 1003,
                firstName: 'The',
                lastName: 'Nguyen Family',
                familyOwesTutor: {
                  amount: '200.00',
                  currencyCode: 'USD',
                },
                familyOwesDirector: {
                  amount: '900.00',
                  currencyCode: 'USD',
                },
              },
            ],
          },
        ],
      },
      {
        programType: ProgramType.ChallengeA,
        tutorOwesDirector: {
          amount: '800.00',
          currencyCode: 'USD',
        },
        familyOwesTutor: {
          amount: '2400.00',
          currencyCode: 'USD',
        },
        familiesOweDirector: {
          amount: '600.00',
          currencyCode: 'USD',
        },
        tutorCount: 1,
        familyCount: 2,
        tutors: [
          {
            firstName: 'Bob',
            lastName: 'Williams',
            enrollmentCount: 2,
            tutorOwesDirector: {
              amount: '400.00',
              currencyCode: 'USD',
            },
            familiesOweTutor: {
              amount: '1200.00',
              currencyCode: 'USD',
            },
            familiesOweDirector: {
              amount: '1200.00',
              currencyCode: 'USD',
            },
            families: [
              {
                userKey: 1004,
                firstName: 'The',
                lastName: 'Brown Family',
                familyOwesTutor: {
                  amount: '600.00',
                  currencyCode: 'USD',
                },
                familyOwesDirector: {
                  amount: '600.00',
                  currencyCode: 'USD',
                },
              },
              {
                userKey: 1005,
                firstName: 'The',
                lastName: 'Lopez Family',
                familyOwesTutor: {
                  amount: '600.00',
                  currencyCode: 'USD',
                },
                familyOwesDirector: {
                  amount: '600.00',
                  currencyCode: 'USD',
                },
              },
            ],
          },
        ],
      },
    ],
  }
